/**
 * Provides branding data from URL
 * using either 'branding' query string
 * or sub domain
 */

import queryString from 'query-string';

export default {
  BRANDING: queryString.parse(window.location.search).branding || // e.g. XXX?branding=custom gives "custom"
  window.location.hostname.split('.')[0] // e.g. custom-domain.guidewire.com gives "custom-domain"
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-branding-js/BrandingData.js
// module id = 299
// module chunks = 0